import { render, staticRenderFns } from "./InsCopyright.vue?vue&type=template&id=94d179d0&scoped=true"
import script from "./InsCopyright.vue?vue&type=script&lang=ts"
export * from "./InsCopyright.vue?vue&type=script&lang=ts"
import style0 from "./InsCopyright.vue?vue&type=style&index=0&id=94d179d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d179d0",
  null
  
)

export default component.exports